<template>
	<div class="operation_box">
		<div class="operation_item">
			<md-button :class="{ 'md-primary': allowSetInterested }" :disabled="!allowSetInterested" @click="approve()">
				{{ $t("marketSoundingDecision.button.interested") }}
			</md-button>
		</div>
		<div class="operation_item">
			<md-button :class="{ 'md-block': allowSetNotInterested }" :disabled="!allowSetNotInterested" @click="reject()">
				{{ $t("marketSoundingDecision.button.notInterested") }}
			</md-button>
		</div>
	</div>
</template>
<script>

export default {
	computed: {
		allowSetInterested() {
			return this.params.data.allowSetInterestedGetter();
		},
		allowSetNotInterested() {
			return this.params.data.allowSetNotInterestedGetter();
		}
	},
	methods: {
		approve() {
			this.params.setInterested(this.params.data);
		},
		reject() {
			this.params.setNotInterested(this.params.data);
		}
	},

}
</script>